import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, timeout } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PersonaSearchRequest, PersonaSearchResponse, ChildrenResponse, PersonDetailResponse, UpdatePhotoResponse, UpdatePersonRequest, PersonSearchItem, GeneralResponse } from '../../core/models/persona/persona.model';

@Injectable({
    providedIn: 'root'
})
export class PersonaService {
    private http = inject(HttpClient);
    private urlAurora = environment.URL_API_AURORA;

    searchByDocument(payload: PersonaSearchRequest): Observable<PersonaSearchResponse> {
        return this.http.post<PersonaSearchResponse>(`${this.urlAurora}api/person/search-by-document`, payload);
    }

    externalSearchByDocument(payload: PersonaSearchRequest): Observable<any> {
        return this.http.post<any>(`${this.urlAurora}api/person/external-search-by-document`, payload);
    }

    getChildrens(personId: string): Observable<ChildrenResponse> {
        return this.http.get<ChildrenResponse>(`${this.urlAurora}api/person/childrens/${personId}`);
    }

    getPersonDetail(personId: string): Observable<PersonDetailResponse> {
        return this.http.get<PersonDetailResponse>(`${this.urlAurora}api/person/${personId}`);
    }

    updatePhoto(personId: string, photoBase64: string): Observable<UpdatePhotoResponse> {
        const payload = { personId, photo: photoBase64 };
        return this.http.post<UpdatePhotoResponse>(`${this.urlAurora}api/person/update-photo`, payload).pipe(
            timeout(15000) // 15 segundos de espera antes de cancelar
        );
    }

    updatePerson(payload: UpdatePersonRequest): Observable<GeneralResponse<unknown>> {
        return this.http.put<GeneralResponse<unknown>>(`${this.urlAurora}api/person/update-person`, payload).pipe(
            timeout(10000)
        );
    }

    searchByName(nombre: string): Observable<GeneralResponse<PersonSearchItem[]>> {
        // Envia el string directamente como JSON body
        return this.http.post<GeneralResponse<PersonSearchItem[]>>(`${this.urlAurora}api/person/search-by-name`, JSON.stringify(nombre), {
            headers: { 'Content-Type': 'application/json' }
        });
    }

    searchByDocumentPost(payload: { documentTypeId: number; documentNumber: string }): Observable<GeneralResponse<PersonSearchItem>> {
        return this.http.post<GeneralResponse<PersonSearchItem>>(`${this.urlAurora}api/person/search-by-document`, payload);
    }
}
